module.exports = __webpack_public_path__ + "img/citazioni_fr.6c946249.svg";